export default "__VITE_ASSET__DBLW1SL1__"